module.exports = __webpack_public_path__ + "img/582.061f325b.png";